import { render, staticRenderFns } from "./IconSquareRight.vue?vue&type=template&id=77fa5e8e"
import script from "./IconSquareRight.vue?vue&type=script&lang=js"
export * from "./IconSquareRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports